const ICONS_MAP = {
  '🛒': 'shopping_cart',
  '🍕': 'local_pizza',
  '🚌': 'directions_bus',
  '💊': 'medication',
  '🚗': 'directions_car',
  '💌': 'volunteer_activism',
  '🏛': 'attractions',
  '🎮': 'sports_esports',
  '👕': 'checkroom',
  '🐶': 'pets',
  '🔮': 'receipt_long',
  '🍷': 'wine_bar',
  '🎁': 'redeem',
  '🏖️': 'beach_access',
  '🎯': 'flag',
  '🌧️': 'thunderstorm',
  '🔨': 'handyman',
  '🍉': 'camping',
};

const DEFAULT_ICON = 'receipt_long';
// The Extended_Pictographic unicode property is a browser feature to detect emojis.
// https://stackoverflow.com/questions/18862256/how-to-detect-emoji-using-javascript
const EMOJI_REGEX = /\p{Extended_Pictographic}/u;
const UNMAPPED_CATEGORIES = [
  'משתנה',
  'לא תזרימית',
  'קבועה',
];

export function V2CategoryIcon(category) {
  if (!category.icon.match(EMOJI_REGEX)) {
    return category.icon;
  }
  if (UNMAPPED_CATEGORIES.includes(category.label)) {
    return category.icon;
  }
  return ICONS_MAP[category.icon] || DEFAULT_ICON;
}
